/** Wires hover/tap behaviour: pointerover outlines the hovered token + every span
 *  in this and other panels whose [cstart, cend] overlaps. Click pins; click-elsewhere clears. */
export function attachHover(root: HTMLElement): () => void {
  let pinned: HTMLElement | null = null;

  function clearAll(): void {
    root.querySelectorAll('.ow-tok.hovered').forEach(el => el.classList.remove('hovered'));
  }
  function highlight(target: HTMLElement): void {
    clearAll();
    const a = Number(target.dataset.cstart);
    const b = Number(target.dataset.cend);
    root.querySelectorAll<HTMLElement>('.ow-tok').forEach(el => {
      const x = Number(el.dataset.cstart);
      const y = Number(el.dataset.cend);
      if (x < b && y > a) el.classList.add('hovered');
    });
  }
  function onPointerOver(e: Event): void {
    if (pinned) return;
    const t = (e.target as HTMLElement).closest<HTMLElement>('.ow-tok');
    if (t) highlight(t);
  }
  function onPointerOut(e: Event): void {
    if (pinned) return;
    const related = (e as PointerEvent).relatedTarget as HTMLElement | null;
    if (!related || !related.closest('.ow-tok')) clearAll();
  }
  function onClick(e: Event): void {
    const t = (e.target as HTMLElement).closest<HTMLElement>('.ow-tok');
    if (t) { pinned = t; highlight(t); }
    else if (pinned) { pinned = null; clearAll(); }
  }
  root.addEventListener('pointerover', onPointerOver);
  root.addEventListener('pointerout', onPointerOut);
  root.addEventListener('click', onClick);
  return () => {
    root.removeEventListener('pointerover', onPointerOver);
    root.removeEventListener('pointerout', onPointerOut);
    root.removeEventListener('click', onClick);
  };
}
